import { color } from "emoreg/const";

export const pillColor = {
  grey: { borderColor: color.grey.base, hoverBackgroundColor: color.grey.light },
  blue: { borderColor: color.blue.base, hoverBackgroundColor: color.blue.lighter },
};
